export default async <T>(inputCacheKey: string, ttl: number, callback: () => Promise<T>, useCache = true): Promise<T> => {
    if (!useCache || process.client) {
        return await callback()
    }

    const redis = await useRedis()

    // Redis is null when the routing/cache sidecar is disabled for this
    // deployment (NUXT_PUBLIC_REDIS_ROUTING_ENABLED !== 'true'). Degrade to an
    // uncached fetch rather than crashing on `redis.get` of null.
    if (!redis) {
        return await callback()
    }

    const cacheKey = `eshop-pwa:${inputCacheKey}`
    const record = await redis.get(cacheKey)

    if (record) {
        return JSON.parse(record)
    }

    const response = await callback()
    redis.set(cacheKey, JSON.stringify(response), 'EX', ttl)

    return response
}
